import { render, staticRenderFns } from "./CameraPhoto.vue?vue&type=template&id=1116e404&"
import script from "./CameraPhoto.vue?vue&type=script&lang=js&"
export * from "./CameraPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports